/* GGC "Shop Your Ride" — tabbed finder (Automotive / Powersports / Wheels / Tires)
 * Clean Turn14-style UX. Reuses ggc-ymm-index.json (year->make->model->tag),
 * ggc-tire-index.json (width->aspect->diameter), and make-types.json (auto vs powersports).
 * Vehicle tabs -> /collections/<all|wheels>/<tag>. Tires tab -> /collections/tires/<size>.
 * Plus "Your Previous Searches" from the localStorage garage.
 */
(function () {
  "use strict";
  var GARAGE_KEY = "ggc_ymm_garage", LAST_KEY = "ggc_ymm_last", ACTIVE_KEY = "ggc_ymm_active";

  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === "class") el.className = attrs[k];
      else if (k === "html") el.innerHTML = attrs[k];
      else if (k === "text") el.textContent = attrs[k];
      else el.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { el.appendChild(c); });
    return el;
  }
  function opt(v, label, dis, sel) { var o = document.createElement("option"); o.value = v; o.textContent = label; if (dis) o.disabled = true; if (sel) o.selected = true; return o; }
  function readJSON(k, f) { try { return JSON.parse(localStorage.getItem(k)) || f; } catch (e) { return f; } }
  function setActive(v) { try { localStorage.setItem(ACTIVE_KEY, JSON.stringify(v)); } catch (e) {} }

  var ICONS = {
    automotive: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M5 11l1.5-4.5A2 2 0 0 1 8.4 5h7.2a2 2 0 0 1 1.9 1.5L19 11h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v1a1 1 0 0 1-2 0v-1H7v1a1 1 0 0 1-2 0v-1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1Zm2.3-1h9.4l-1-3H8.3l-1 3ZM6.5 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm11 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/></svg>',
    powersports: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M5 18a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm14 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM5 11a4 4 0 0 0-1 .13L6 8h3l1.2 2H14l-1.5-2H11V8h4l2 3h2a4 4 0 1 1-1.6.34L16.8 9.8 14.5 13H9.9A5 5 0 0 0 5 11Z"/></svg>',
    wheels: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 3a7 7 0 0 1 6.7 5h-4a3 3 0 0 0-1.2-1.4l.3-3.5A7 7 0 0 1 12 5Zm-1.8.3l.3 3.5A3 3 0 0 0 9.3 10h-4A7 7 0 0 1 10.2 5.3ZM5 12a7 7 0 0 1 .3-2h4a3 3 0 0 0 0 0l-2.7 2.6A7 7 0 0 1 5 12Zm3.5 6.2L11 15a3 3 0 0 0 2 0l2.5 3.2a7 7 0 0 1-7 0ZM12 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/></svg>',
    tires: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 4a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm0 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/></svg>'
  };

  var TABS = [
    { id: "automotive", label: "Automotive", kind: "vehicle", dest: "all", filter: "automotive" },
    { id: "powersports", label: "Powersports", kind: "vehicle", dest: "all", filter: "powersports" },
    { id: "wheels", label: "Wheels", kind: "wheels" },
    { id: "tires", label: "Tires", kind: "tires" }
  ];

  function TabWidget(root) {
    this.root = root;
    this.indexUrl = root.getAttribute("data-index-url");
    this.tireIndexUrl = root.getAttribute("data-tire-index-url");
    this.makeTypesUrl = root.getAttribute("data-make-types-url");
    this.wheelBoltUrl = root.getAttribute("data-wheel-bolt-url");
    this.collection = root.getAttribute("data-tire-collection") || "tires";
    this.wheelBolt = null;
    this.activeTab = "automotive";
    this.tree = null; this.tireTree = null; this.makeTypes = null;
    this.sel = { year: "", make: "", model: "" };
    this.tsel = { w: "", a: "", d: "" };
    this.renderShell();
    this.bindLazy();
  }

  TabWidget.prototype.bindLazy = function () {
    var self = this, fired = false, go = function () { if (!fired) { fired = true; self.load(); } };
    // load when the Shop Your Ride modal opens, or on first interaction
    var btn = document.querySelector(".custm-button"); if (btn) btn.addEventListener("click", go);
    this.root.addEventListener("mouseenter", go, { once: true });
    this.root.addEventListener("click", go, { once: true });
    setTimeout(go, 4000); // safety: load shortly after page settle
  };

  TabWidget.prototype.load = function () {
    var self = this;
    if (this._loading || this.tree) return; this._loading = true;
    this.setStatus("Loading…");
    var jget = function (u) { return u ? fetch(u).then(function (r) { return r.json(); }).catch(function () { return null; }) : Promise.resolve(null); };
    Promise.all([
      jget(this.indexUrl), jget(this.tireIndexUrl), jget(this.makeTypesUrl), jget(this.wheelBoltUrl)
    ]).then(function (res) {
      self.tree = (res[0] || {}).tree; self.tireData = res[1] || {}; self.tireTree = self.tireData.tree || {}; self.makeTypes = res[2] || {};
      self.wheelBolt = res[3];
      self.setStatus(""); self.renderTab();
    }).catch(function () { self._loading = false; self.setStatus("Could not load. Please retry."); });
  };

  TabWidget.prototype.renderShell = function () {
    var self = this;
    this.root.innerHTML = "";
    var wrap = h("div", { class: "ggc-tabs" });
    // tab nav
    var nav = h("div", { class: "ggc-tabs__nav" });
    TABS.forEach(function (t) {
      var b = h("button", { class: "ggc-tabs__tab" + (t.id === self.activeTab ? " is-active" : ""), type: "button", "data-tab": t.id });
      b.appendChild(h("span", { class: "ggc-tabs__icon", html: ICONS[t.id] }));
      b.appendChild(h("span", { text: t.label }));
      b.addEventListener("click", function () { self.activeTab = t.id; self.refreshNav(); self.renderTab(); });
      nav.appendChild(b);
    });
    wrap.appendChild(nav);
    this.body = h("div", { class: "ggc-tabs__body" });
    wrap.appendChild(this.body);
    this.statusEl = h("div", { class: "ggc-tabs__status", "aria-live": "polite" });
    wrap.appendChild(this.statusEl);
    this.prevEl = h("div", { class: "ggc-tabs__prev" });
    wrap.appendChild(this.prevEl);
    this.nav = nav;
    this.root.appendChild(wrap);
    this.renderPrevious();
  };

  TabWidget.prototype.refreshNav = function () {
    var self = this;
    Array.prototype.forEach.call(this.nav.children, function (b) {
      b.classList.toggle("is-active", b.getAttribute("data-tab") === self.activeTab);
    });
  };

  TabWidget.prototype.setStatus = function (m) { if (this.statusEl) this.statusEl.textContent = m || ""; };

  TabWidget.prototype.renderTab = function () {
    if (!this.tree) { this.body.innerHTML = ""; return; }
    var tab = TABS.filter(function (t) { return t.id === this.activeTab; }, this)[0];
    this.body.innerHTML = "";
    if (tab.kind === "tires") this.renderTires();
    else if (tab.kind === "wheels") this.renderWheels();
    else this.renderVehicle(tab);
  };

  /* ----- Wheels tab (shop by bolt pattern) ----- */
  TabWidget.prototype.renderWheels = function () {
    var self = this;
    var data = this.wheelBolt;
    if (!data || !data.items || !data.items.length) {
      this.body.appendChild(h("div", { class: "ggc-tabs__status", text: "Wheel finder unavailable. Please retry." }));
      return;
    }
    this.body.appendChild(h("p", { class: "ggc-tabs__hint", html: 'Select your wheel <strong>bolt pattern</strong> to see every wheel that fits. <span class="ggc-tabs__sub">Not sure? It\'s stamped on your factory wheel, or in your driver\'s door jamb.</span>' }));
    var fields = h("div", { class: "ggc-tabs__fields" });
    this.wSel = this.mkSel("Bolt pattern");
    fields.appendChild(this.fieldWrap("Bolt pattern", true, this.wSel));
    this.body.appendChild(fields);
    this.wSel.innerHTML = ""; this.wSel.appendChild(opt("", "-Choose-", true, true));
    data.items.forEach(function (it) {
      var o = opt(it.handle, it.label + "  (" + it.count + ")");
      self.wSel.appendChild(o);
    });
    this.wSel.disabled = false;
    var actions = h("div", { class: "ggc-tabs__actions" });
    this.wbtn = h("button", { class: "ggc-tabs__search", type: "button", text: "Find wheels" });
    this.wbtn.disabled = true;
    this.wSel.addEventListener("change", function () { self.wbtn.disabled = !self.wSel.value; });
    this.wbtn.addEventListener("click", function () {
      var handle = self.wSel.value; if (!handle) return;
      var it = data.items.filter(function (x) { return x.handle === handle; })[0];
      if (it) self.addPrevious({ tag: it.tag, label: it.bp + " Wheels", handle: it.handle, dest: data.collection || "wheel" });
      window.location.assign("/collections/" + (data.collection || "wheel") + "/" + handle);
    });
    actions.appendChild(this.wbtn);
    this.body.appendChild(actions);
  };

  /* ----- Vehicle tabs (Automotive / Powersports / Wheels) ----- */
  TabWidget.prototype.renderVehicle = function (tab) {
    var self = this;
    this.sel = { year: "", make: "", model: "" };
    var fields = h("div", { class: "ggc-tabs__fields" });
    this.selYear = this.mkSel("Year");
    this.selMake = this.mkSel("Make");
    this.selModel = this.mkSel("Model (optional)");
    fields.appendChild(this.fieldWrap("Year", true, this.selYear));
    fields.appendChild(this.fieldWrap("Make", true, this.selMake));
    fields.appendChild(this.fieldWrap("Model", false, this.selModel));
    this.body.appendChild(fields);

    var years = Object.keys(this.tree).sort(function (a, b) { return parseInt(b) - parseInt(a); });
    this.fill(this.selYear, years); this.selYear.disabled = false;
    this.selYear.addEventListener("change", function () { self.onYear(tab); });
    this.selMake.addEventListener("change", function () { self.onMake(tab); });
    this.selModel.addEventListener("change", function () { self.sel.model = self.selModel.value; self.updateBtn(tab); });

    var actions = h("div", { class: "ggc-tabs__actions" });
    this.btn = h("button", { class: "ggc-tabs__search", type: "button", text: tab.id === "wheels" ? "Find wheels" : "Search" });
    this.btn.disabled = true;
    this.btn.addEventListener("click", function () { self.go(tab); });
    actions.appendChild(this.btn);
    this.body.appendChild(actions);
    if (tab.id === "automotive") {
      // Performance path: same vehicle, Stage 1/2/3 parts verified to fit (page /pages/build)
      var build = h("div", { class: "ggc-tabs__build" });
      build.appendChild(h("span", { class: "ggc-tabs__build-t", text: "Want a performance build?" }));
      var bb = h("button", { class: "ggc-tabs__build-btn", type: "button", text: "Build your stage" });
      bb.addEventListener("click", function () { self.goBuild(); });
      build.appendChild(bb);
      this.body.appendChild(build);
    }
  };

  TabWidget.prototype.goBuild = function () {
    var tag = this.tagFor();
    if (tag) {
      var label = [this.sel.year, this.sel.make, this.sel.model || ""].filter(Boolean).join(" ");
      setActive({ year: this.sel.year, make: this.sel.make, model: this.sel.model, tag: tag, label: label });
      this.addPrevious({ tag: tag, label: label, year: this.sel.year, make: this.sel.make, model: this.sel.model });
    }
    window.location.assign("/pages/build");
  };

  TabWidget.prototype.makesFor = function (tab) {
    var all = {};
    Object.keys(this.tree).forEach(function (y) { Object.keys(this.tree[y]).forEach(function (m) { all[m] = 1; }); }, this);
    var list = Object.keys(all);
    if (!tab.filter || !this.makeTypes) return list.sort();
    var allowed = {}; (this.makeTypes[tab.filter] || []).forEach(function (m) { allowed[m] = 1; });
    return list.filter(function (m) { return allowed[m]; }).sort();
  };

  TabWidget.prototype.onYear = function (tab) {
    this.sel.year = this.selYear.value; this.sel.make = ""; this.sel.model = "";
    var y = this.sel.year;
    if (y && this.tree[y]) {
      var avail = {}; Object.keys(this.tree[y]).forEach(function (m) { avail[m] = 1; });
      var makes = this.makesFor(tab).filter(function (m) { return avail[m]; });
      this.fill(this.selMake, makes); this.selMake.disabled = false;
    } else this.reset(this.selMake);
    this.reset(this.selModel); this.updateBtn(tab);
  };
  TabWidget.prototype.onMake = function (tab) {
    this.sel.make = this.selMake.value; this.sel.model = "";
    var node = (this.tree[this.sel.year] || {})[this.sel.make];
    if (this.sel.make && node) { this.fill(this.selModel, Object.keys(node).sort()); this.selModel.disabled = false; }
    else this.reset(this.selModel);
    this.updateBtn(tab);
  };
  TabWidget.prototype.tagFor = function () {
    var node = this.tree[this.sel.year] && this.tree[this.sel.year][this.sel.make];
    if (!node) return "";
    if (this.sel.model) return node[this.sel.model] || "";
    // model optional: if one model, use it; else require model for a precise tag
    var keys = Object.keys(node); return keys.length === 1 ? node[keys[0]] : "";
  };
  TabWidget.prototype.updateBtn = function (tab) {
    var ok = !!(this.sel.year && this.sel.make && this.tagFor());
    this.btn.disabled = !ok;
  };
  TabWidget.prototype.label = function () { return [this.sel.year, this.sel.make, this.sel.model].filter(Boolean).join(" "); };
  TabWidget.prototype.go = function (tab) {
    var tag = this.tagFor(); if (!tag) return;
    var label = [this.sel.year, this.sel.make, this.sel.model || ""].filter(Boolean).join(" ");
    setActive({ year: this.sel.year, make: this.sel.make, model: this.sel.model, tag: tag, label: label });
    try { localStorage.setItem(LAST_KEY, JSON.stringify(this.sel)); } catch (e) {}
    this.addPrevious({ tag: tag, label: label, year: this.sel.year, make: this.sel.make, model: this.sel.model });
    if (tab.dest === "all" && window.GGCHubUrl) window.location.assign(window.GGCHubUrl(tag, label));
    else window.location.assign("/collections/" + tab.dest + "/" + encodeURIComponent(tag));
  };

  /* ----- Tires tab ----- */
  // Metric (Width / Aspect / Rim) and truck flotation (Overall diameter / Section width / Rim) trees both come from
  // ggc-tire-index.json. Submit goes to the exact-size tag collection: /collections/tires/<handle> (e.g. 245-40r18).
  TabWidget.prototype.tireCur = function () {
    var d = this.tireData || {};
    if (this.tmode === "flot" && d.flotation && d.flotation.tree) return { tree: d.flotation.tree, order: d.flotation.order || ["Overall diameter", "Section width", "Wheel diameter"] };
    return { tree: this.tireTree || {}, order: d.order || ["Width", "Aspect ratio", "Wheel diameter"] };
  };
  TabWidget.prototype.renderTires = function () {
    var self = this; this.tsel = { w: "", a: "", d: "" };
    if (!this.tmode) this.tmode = "metric";
    var d = this.tireData || {};
    var act = readJSON(ACTIVE_KEY, null);
    if (act && act.label) {
      this.body.appendChild(h("div", { class: "ggc-tabs__veh", text: "Tire replacements for your " + act.label }));
      this.body.appendChild(h("p", { class: "ggc-tabs__hint", text: "Enter your current tire size. It's printed on the sidewall, e.g. 255/40R20." }));
    }
    var hasFlot = !!(d.flotation && d.flotation.tree && Object.keys(d.flotation.tree).length);
    if (hasFlot) {
      var modes = h("div", { class: "ggc-tabs__modes", role: "group", "aria-label": "Tire size type" });
      [["metric", "Car, SUV & street"], ["flot", "Truck flotation (35x12.50)"]].forEach(function (m) {
        var b = h("button", { type: "button", class: "ggc-tabs__mode" + (self.tmode === m[0] ? " is-active" : ""), text: m[1], "aria-pressed": self.tmode === m[0] ? "true" : "false" });
        b.addEventListener("click", function () { if (self.tmode === m[0]) return; self.tmode = m[0]; self.renderTab(); });
        modes.appendChild(b);
      });
      this.body.appendChild(modes);
    }
    var cur = this.tireCur(), tree = cur.tree, order = cur.order;
    var num = function (a, b) { return parseFloat(a) - parseFloat(b); };
    var fields = h("div", { class: "ggc-tabs__fields" });
    this.tW = this.mkSel(order[0]); this.tA = this.mkSel(order[1]); this.tD = this.mkSel(order[2]);
    fields.appendChild(this.fieldWrap(order[0], true, this.tW));
    fields.appendChild(this.fieldWrap(order[1], true, this.tA));
    fields.appendChild(this.fieldWrap(order[2], true, this.tD));
    this.body.appendChild(fields);
    this.fill(this.tW, Object.keys(tree).sort(num)); this.tW.disabled = false;
    this.tW.addEventListener("change", function () {
      self.tsel.w = self.tW.value; self.tsel.a = ""; self.tsel.d = "";
      if (self.tsel.w && tree[self.tsel.w]) { self.fill(self.tA, Object.keys(tree[self.tsel.w]).sort(num)); self.tA.disabled = false; } else self.reset(self.tA);
      self.reset(self.tD); self.tbtn.disabled = true;
    });
    this.tA.addEventListener("change", function () {
      self.tsel.a = self.tA.value; self.tsel.d = "";
      var node = (tree[self.tsel.w] || {})[self.tsel.a];
      if (self.tsel.a && node) { self.fill(self.tD, Object.keys(node).sort(num)); self.tD.disabled = false; } else self.reset(self.tD);
      self.tbtn.disabled = true;
    });
    this.tD.addEventListener("change", function () { self.tsel.d = self.tD.value; self.tbtn.disabled = !self.tireHandle(); });
    var actions = h("div", { class: "ggc-tabs__actions" });
    this.tbtn = h("button", { class: "ggc-tabs__search", type: "button", text: "Find tires" }); this.tbtn.disabled = true;
    this.tbtn.addEventListener("click", function () {
      var handle = self.tireHandle(); if (!handle) return;
      window.location.assign("/collections/tires/" + encodeURIComponent(handle));
    });
    actions.appendChild(this.tbtn); this.body.appendChild(actions);
  };
  TabWidget.prototype.tireHandle = function () { var t = this.tireCur().tree; var n = t[this.tsel.w] && t[this.tsel.w][this.tsel.a]; return (n && n[this.tsel.d]) || ""; };

  /* ----- shared field helpers ----- */
  TabWidget.prototype.mkSel = function (ph) { var s = document.createElement("select"); s.className = "ggc-tabs__select"; s.disabled = true; s.appendChild(opt("", "-Choose-", true, true)); s._ph = ph; return s; };
  TabWidget.prototype.fieldWrap = function (label, req, sel) { var f = h("label", { class: "ggc-tabs__field" }); f.appendChild(h("span", { class: "ggc-tabs__label", html: label + (req ? ' <em>*</em>' : ' <em class="ggc-tabs__opt">(optional)</em>') })); f.appendChild(sel); return f; };
  TabWidget.prototype.fill = function (s, vals) { s.innerHTML = ""; s.appendChild(opt("", "-Choose-", true, true)); vals.forEach(function (v) { s.appendChild(opt(v, v)); }); };
  TabWidget.prototype.reset = function (s) { s.innerHTML = ""; s.appendChild(opt("", "-Choose-", true, true)); s.disabled = true; };

  /* ----- Previous searches (garage) ----- */
  TabWidget.prototype.addPrevious = function (v) {
    var g = readJSON(GARAGE_KEY, []);
    if (!g.some(function (x) { return x.tag === v.tag && x.label === v.label; })) { g.unshift(v); g = g.slice(0, 12); try { localStorage.setItem(GARAGE_KEY, JSON.stringify(g)); } catch (e) {} }
  };
  TabWidget.prototype.renderPrevious = function () {
    var self = this, g = readJSON(GARAGE_KEY, []);
    this.prevEl.innerHTML = "";
    if (!g.length) return;
    this.prevEl.appendChild(h("div", { class: "ggc-tabs__prev-title", text: "Your Previous Searches" }));
    var grid = h("div", { class: "ggc-tabs__prev-grid" });
    g.forEach(function (v) {
      var a = h("button", { class: "ggc-tabs__prev-link", type: "button", text: v.label });
      a.addEventListener("click", function () {
        setActive(v);
        if (v.handle && v.dest) window.location.assign("/collections/" + v.dest + "/" + v.handle);
        else window.location.assign(window.GGCHubUrl ? window.GGCHubUrl(v.tag, v.label) : "/collections/all/" + encodeURIComponent(v.tag));
      });
      grid.appendChild(a);
    });
    this.prevEl.appendChild(grid);
  };

  function init() {
    document.querySelectorAll("[data-ggc-tabs]").forEach(function (n) { if (!n.__t) { n.__t = true; new TabWidget(n); } });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  window.GGCTabsInit = init;
})();
